import { Chip, useTheme } from '@mui/material';
import React, { FC } from 'react';

export type SlideCountPosition = 'topLeft' | 'topRight';

export interface SlideCountProps {
    currentSlide: number;
    totalSlides: number;
    position?: SlideCountPosition;
}

const SlideNavigationBadge: FC<SlideCountProps> = ({
                                                       currentSlide,
                                                       totalSlides,
                                                       position,
                                                   }) => {
    const theme = useTheme();
    return (
            <Chip
                size="small"
                sx={{
                    position: 'absolute',
                    backgroundColor: theme.palette.white.main,
                    opacity: '80%',
                    borderRadius: '4px',
                    top: 8,
                    ...(position === 'topRight' ? { right: 8 } : { left: 8 }),
                    height: '20px',
                    fontWeight: 600,
                    zIndex: 1,
                    '> span': {
                        paddingLeft: '4px',
                        paddingRight: '4px',
                        fontWeight: 600,
                    },
                }}
                label={`${currentSlide}/${totalSlides}`}
                data-testid="slide-navigation-badge"
            />
    );
};

export default SlideNavigationBadge;

SlideNavigationBadge.defaultProps = {
    position: 'topLeft',
};
